<template>
  <article class="default-text">
    <h2>Aktuálně</h2>
    <p class="big-text">
      {{ latestItem.value }}
    </p>
    <hr>
    <h2>Tabulka</h2>
    <v-simple-table>
      <template>
        <thead>
          <tr>
            <th>Rok</th>
            <th>Okresy</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items">
            <td>{{ item.label }}</td>
            <td>{{ item.value }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <hr>
    <p>Aktualizováno {{ updatedAtFormatted }}</p>
    <v-btn
      :href="printChart"
      depressed
      x-large
      class="gradient-button white--text"
    >
      Stáhnout statistiku v CSV
    </v-btn>
  </article>
</template>

<script>
import stats from '../../json/top_3_lowest.json'
import statsMixin from '../statsMixin'

export default {
  name: 'VCardTop3LowestHomepage',
  mixins: [
    statsMixin
  ],
  props: {
    title: {
      type: String,
      default: () => { return '' }
    },
    detailUrl: {
      type: String,
      default: () => {
        return '/statistiky/top-3-nejmensi.html'
      }
    }
  },
  data () {
    return {
      items: stats.data,
      meta: stats.meta
    }
  },
  methods: {
    createChart () {
      // these stats have no chart
    }
  }
}
</script>
